import { render, staticRenderFns } from "./22.vue?vue&type=template&id=607fc94a&scoped=true&"
import script from "./22.vue?vue&type=script&lang=js&"
export * from "./22.vue?vue&type=script&lang=js&"
import style0 from "./22.vue?vue&type=style&index=0&id=607fc94a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607fc94a",
  null
  
)

export default component.exports